import {Primitive} from 'ts-essentials';
import {compile} from './compile';
import {ExtractMessageValues, parse} from './parse';

export interface Options {
  prefix: string;
  suffix: string;
}

export const createTranslator =
  (
    rawMessages: Partial<Record<string, string>>,
    options: Options = {
      prefix: '{',
      suffix: '}',
    },
    usedCallback?: (key: string, value: string) => void,
  ) =>
  <
    Key extends string,
    Values extends Record<
      ExtractMessageValues<
        Key extends keyof Messages ? Messages[Key] : Key
      >[number],
      Primitive
    >,
    Messages extends Record<string, string> | undefined = undefined,
  >(
    ...[i18nKey, values]: keyof Values extends never
      ? [i18nKey: Key]
      : [i18nKey: Key, values: Values]
  ) => {
    const value = rawMessages[i18nKey] ?? i18nKey;
    const compiledValue = compile(parse(value), values, options);
    usedCallback?.(i18nKey, value);
    return compiledValue;
  };

export type TranslationFunction = ReturnType<typeof createTranslator>;
